class ElixMemberVideo extends HTMLElement {
  async connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.hidden = true;
    const c = JSON.parse(
      this.querySelector("[data-member-config]").textContent,
    );
    if (!c.enabled) return;
    try {
      const r = await fetch(c.proxy + "/resources", {
        credentials: "same-origin",
      });
      if (!r.ok) return;
      const { video } = await r.json();
      if (!video) return;
      const url = new URL(video.url);
      if (
        url.protocol !== "https:" ||
        ![
          "cdn.shopify.com",
          "www.youtube.com",
          "youtu.be",
          "vimeo.com",
          "www.vimeo.com",
        ].includes(url.hostname)
      )
        return;
      const heading = document.createElement("h2");
      heading.textContent = c.strings.video;
      const link = document.createElement("a");
      link.className = "em-button";
      link.textContent =
        video.title[c.locale] || video.title.en || c.strings.video;
      link.href = url.href;
      link.target = "_blank";
      link.rel = "noopener";
      this.append(heading, link);
      this.hidden = false;
    } catch {
      /* Unconfigured resources remain hidden. */
    }
  }
}
if (!customElements.get("elix-member-video"))
  customElements.define("elix-member-video", ElixMemberVideo);
